/* eslint-disable no-undef */

export interface Config {
    supportedStaticConfigurationSchemaMajor: number;
    environment: string;
    apiEndpoint: string;
    operationTimeout: number;
    uploads: {
        maxSize: number;
        extensions: string[];
    };
    firebaseConfig: {
        apiKey: string;
        authDomain: string;
        databaseURL: string;
        projectId: string;
        storageBucket: string;
        messagingSenderId: string;
        appId: string;
        measurementId: string;
    };
}

export const defaultConfig = {
    supportedStaticConfigurationSchemaMajor: 2,
    environment: "default",
    apiEndpoint: "undefined",
    operationTimeout: 5000,
    uploads: {
        maxSize: 20 * 1024 * 1024,
        extensions: ["jpg", "jpeg", "pdf", "png"],
    },
};

let config: Config;

if (process.env.REACT_APP_ENVIRONMENT === "review") {
  console.log("loading review config");
  config = { ...defaultConfig, ...require("./config.review.ts").default };
} else if (process.env.REACT_APP_ENVIRONMENT === "staging") {
  console.log("loading staging config");
  config = { ...defaultConfig, ...require("./config.staging.ts").default };
} else if (process.env.REACT_APP_ENVIRONMENT === "production") {
  console.log("loading production config");
  config = { ...defaultConfig, ...require("./config.production.ts").default };
} else if (process.env.REACT_APP_ENVIRONMENT === "ci") {
  console.log("loading ci config");
  config = { ...defaultConfig, ...require("./config.ci.ts").default };
} else {
  console.log("loading local config");
  config = { ...defaultConfig, ...require("./config.local.ts").default };
}

export default config;
